//import Enumerable from 'linq';

export function getTours(includeDeleted = false) {
    const prereq = getServerSideData('prereq') || [];

    const res = [];

    for (const item of prereq.filter(i => i.type == 'tour')) {
        if (!includeDeleted && item.isDeleted) continue;
        if (res.some(i => i.id == item.id)) continue;

        res.push({ id: item.id, name: makeName(item) });
    }

    res.sort((a, b) => {
        if (a.name?.toLowerCase() > b.name?.toLowerCase()) return 1;
        if (a.name?.toLowerCase() < b.name?.toLowerCase()) return -1;
        return 0;
    });

    return res;
}

export function getContextHelps(includeDeleted = false) {
    const prereq = getServerSideData('prereq') || [];

    const res = [];

    for (const item of prereq.filter(i => i.type == 'ctx')) {
        if (!includeDeleted && item.isDeleted) continue;
        if (res.some(i => i.id == item.id)) continue;

        res.push({ id: item.id, name: makeName(item) });
    }

    res.sort((a, b) => {
        if (a.name?.toLowerCase() > b.name?.toLowerCase()) return 1;
        if (a.name?.toLowerCase() < b.name?.toLowerCase()) return -1;
        return 0;
    });

    return res;
}

export function getChecklists(includeDeleted = false) {
    const prereq = getServerSideData('prereq') || [];

    const res = [];

    for (const item of prereq.filter(i => i.type == 'chcklst')) {
        if (!includeDeleted && item.isDeleted) continue;
        if (res.some(i => i.id == item.id)) continue;

        res.push({ id: item.id, name: makeName(item) });
    }

    res.sort((a, b) => {
        if (a.name?.toLowerCase() > b.name?.toLowerCase()) return 1;
        if (a.name?.toLowerCase() < b.name?.toLowerCase()) return -1;
        return 0;
    });

    return res;
}

export function getName(type, itemId) {
    const prereq = getServerSideData('prereq') || [];

    const t = prereq.filter(i => i.type == type && i.id == itemId)[0];

    return t ? t.name : '(deleted)'
}


export function getItemName(type, itemId, cardId) {
    const prereq = getServerSideData('prereq') || [];

    const t = prereq.filter(i => i.type == type && i.id == itemId && i.itemId == cardId)[0];

    return t ? t.itemName : '(deleted)'
}

function makeName(item) {
    let name = item.name;

    if (item.isDeleted) {
        name += ' (deleted)';
    }

    return name;
}


function getServerSideData(key) {
    if (window.serverSide) {
        return window.serverSide[key];
    }
}